function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { generateId, t } from '../utils';
import classnames from 'classnames';
import { DatePicker as FabricDatePicker, DayOfWeek, FirstWeekOfYear } from '@fluentui/react';
import { LabelWithCallout } from '../LabelWithCallout';
import { getClassNames, getCalendarClassNames } from './DatePicker.classNames';
import { ErrorMessage } from '../ErrorMessage';
import { DEFAULTFORMATDATE, DEFAULTPARSEDATEFROMSTRING, monthsForLocale, weekdaysForLocale } from './utils';
/**
 * @deprecated Komponenten er erstattet av DatePicker fra "@skatteetaten/ds-forms"
 *
 * visibleName DatePicker (Datovelger)
 */

export const DatePicker = props => {
  const {
    ariaLabel,
    calloutFloating,
    datepickerCalloutProps,
    children,
    className,
    editable,
    errorMessage = undefined,
    id,
    invalidInputErrorMessage,
    isOutOfBoundsErrorMessage,
    isRequired,
    isRequiredErrorMessage,
    help,
    label,
    labelButtonAriaLabel,
    labelWithCalloutProps,
    language = 'no',
    onCalloutToggle,
    readonlyMode,
    requiredWithMark = false
  } = props,
        rest = _objectWithoutProperties(props, ["ariaLabel", "calloutFloating", "datepickerCalloutProps", "children", "className", "editable", "errorMessage", "id", "invalidInputErrorMessage", "isOutOfBoundsErrorMessage", "isRequired", "isRequiredErrorMessage", "help", "label", "labelButtonAriaLabel", "labelWithCalloutProps", "language", "onCalloutToggle", "readonlyMode", "requiredWithMark"]);

  const defaultValues = {
    allowTextInput: true,
    dateTimeFormatter: undefined,
    disabled: false,
    firstDayOfWeek: language !== 'en' ? DayOfWeek.Monday : DayOfWeek.Sunday,
    firstWeekOfYear: 0,
    // FirstDay = 0, FirstFullWeek = 1, FirstFourDayWeek = 2
    formatDate: DEFAULTFORMATDATE,
    initialPickerDate: new Date(),
    isMonthPickerVisible: true,
    isRequired: false,
    highlightCurrentMonth: true,
    parseDateFromString: DEFAULTPARSEDATEFROMSTRING,
    pickerAriaLabel: t('datepicker.calendar'),
    showGoToToday: true,
    showMonthPickerAsOverlay: false,
    showWeekNumbers: true
  };
  const generatedId = generateId();
  const mainId = id ? id : 'datepicker-' + generatedId;
  const inputId = mainId + '-input';
  const labelId = mainId + '-label';
  const datePickerRef = React.useRef();
  const [editMode, setEditMode] = React.useState(false);
  const [readOnly, setReadOnly] = React.useState(readonlyMode && !editMode);
  const [requiredInternalState, setRequiredInternalState] = React.useState(false);
  React.useEffect(() => {
    setReadOnly(readonlyMode && !editMode);
  }, [editMode, readonlyMode]);
  const DEFAULT_DATE_FORMAT = 'DD.MM.YYYY';
  const DEFAULT_STRINGS = {
    months: monthsForLocale(language, 'long'),
    shortMonths: monthsForLocale(language, 'short'),
    days: weekdaysForLocale(language, 'long'),
    shortDays: weekdaysForLocale(language, 'short'),
    goToToday: t('datepicker.goToToday'),
    prevMonthAriaLabel: t('datepicker.prevMonthAriaLabel'),
    nextMonthAriaLabel: t('datepicker.nextMonthAriaLabel'),
    prevYearAriaLabel: t('datepicker.prevYearAriaLabel'),
    nextYearAriaLabel: t('datepicker.nextYearAriaLabel'),
    invalidInputErrorMessage: t('datepicker.invalidInputErrorMessage', {
      DEFAULT_DATE_FORMAT
    }),

    /** Automatisk utvide høyde (ved multiline) */
    isOutOfBoundsErrorMessage: t('datepicker.isOutOfBoundsErrorMessage'),
    isRequiredErrorMessage: t('datepicker.isRequiredErrorMessage')
  };

  const onEdit = () => {
    if (!editMode) {
      datePickerRef.current && datePickerRef.current.focus();
    }

    setEditMode(!editMode);
  };

  const onBlur = e => {
    rest.onBlur && rest.onBlur(e);
    setRequiredInternalState(isRequired || requiredWithMark); // TO-DO datepicker er blitt en FunctionComponent. Det er ikke mulig å aksessere intern state på denne måten
    // Filled out feature request here: https://github.com/microsoft/fluentui/issues/19512
    // if (editMode && !datePickerRef.current?.state.isDatePickerShown) {
    //   setEditMode(!editMode);
    // }
  };

  return /*#__PURE__*/React.createElement("div", {
    id: id
  }, /*#__PURE__*/React.createElement(LabelWithCallout, _extends({
    id: labelId,
    inputId: inputId + '-label',
    label: label,
    requiredMark: requiredWithMark,
    buttonAriaLabel: labelButtonAriaLabel,
    help: help,
    calloutFloating: calloutFloating,
    onCalloutToggle: onCalloutToggle,
    editable: editable,
    editFunction: onEdit,
    readOnly: readonlyMode,
    calloutProps: _objectSpread({}, labelWithCalloutProps?.calloutProps)
  }, labelWithCalloutProps)), /*#__PURE__*/React.createElement(FabricDatePicker, _extends({}, defaultValues, rest, {
    id: inputId,
    ariaLabel: ariaLabel,
    className: classnames(getClassNames(_objectSpread({
      errorMessage,
      readonlyMode: readOnly
    }, rest)), className),
    isRequired: requiredInternalState,
    componentRef: ref => {
      datePickerRef.current = ref;
    },
    calloutProps: _objectSpread(_objectSpread({}, datepickerCalloutProps), {}, {
      className: classnames(getCalendarClassNames(props), datepickerCalloutProps?.className)
    }),
    disabled: readOnly ? true : rest.disabled,
    onBlur: onBlur,
    strings: _objectSpread(_objectSpread({}, DEFAULT_STRINGS), {}, {
      isRequiredErrorMessage: isRequiredErrorMessage ? isRequiredErrorMessage : DEFAULT_STRINGS.isRequiredErrorMessage,
      isOutOfBoundsErrorMessage: isOutOfBoundsErrorMessage ? isOutOfBoundsErrorMessage : DEFAULT_STRINGS.isOutOfBoundsErrorMessage,
      invalidInputErrorMessage: invalidInputErrorMessage ? invalidInputErrorMessage : DEFAULT_STRINGS.invalidInputErrorMessage
    })
  }), children), errorMessage && typeof errorMessage === 'string' ? /*#__PURE__*/React.createElement(ErrorMessage, null, errorMessage) : errorMessage);
};
export default DatePicker;
export { DayOfWeek, FirstWeekOfYear };